import type { ButtonHTMLAttributes } from "react";
import { X } from "lucide-react";
import { Button } from "./Button.js";

/** Schließen-Button für Dialoge — wrappt `Button variant="icon"` statt eigenem Markup je Aufrufer. */
export function CloseButton({
  className,
  "aria-label": ariaLabel = "Schließen",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <Button
      variant="icon"
      aria-label={ariaLabel}
      className={className}
      {...rest}
    >
      <X />
    </Button>
  );
}
